export default {
  placeholder: '搜索',
  cancelText: '取消',
};
